import { render } from "./orionDatas.vue?vue&type=template&id=38d7f96c&scoped=true"
import script from "./orionDatas.vue?vue&type=script&lang=js"
export * from "./orionDatas.vue?vue&type=script&lang=js"

import "./orionDatas.vue?vue&type=style&index=0&id=38d7f96c&scoped=true&lang=css"

import exportComponent from "/home/tyamada/ckan-ext-dev/yamanashi-dataplatform-admin-system-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d7f96c"]])

export default __exports__